import { gql } from 'graphql-request';

import {
  ProductSearchID,
  ProductSearchSearchValue,
  ProductSearchUserID,
  ProductSearchUUID
} from '../productsSearchesTypes';

export interface FetchProductSearchesQueryResponse {
  id: ProductSearchID;
  uuid: ProductSearchUUID;
  searchValue: ProductSearchSearchValue;
  userId: ProductSearchUserID;
}

export const FETCH_PRODUCT_SEARCHES_QUERY = gql`
  query ProductSearches(
    $filters: ProductSearchesFilters
    $sort: [ProductSearchesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
  ) {
    productSearches(
      filters: $filters
      sort: $sort
      offset: $offset
      limit: $limit
      source: $source
    ) {
      nodes {
        id
        uuid
        searchValue
        userId
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
